<template>
  <div class="root" :last="lastEntry">
    <div class="row">
      <div class="col-md-3">
        <span :class="{'indicator': true, 'red': (card.Type === 'Invoice - Rush')}">{{card.Type}}</span>
      </div>
      <div class="col-md-3">
        <div v-if="card.NeedsApproval !== 'Card Request' && !card.NeedsApproval.includes('Card') && !card.NeedsApproval.includes('ER')">
          <span class="item-label">Needs Approval</span><br />
          <span class="item" :title="card.NeedsApproval"><a :href="card.NeedsAprovalLink">{{card.NeedsApproval}}</a></span>
        </div>
      </div>
      <div class="col-md-3">
        <span v-if="fullSupplierName" class="item-label">Supplier</span><br />
        <span v-if="fullSupplierName && card.SupplierLink" class="item" :title="fullSupplierName"><a :href="card.SupplierLink">{{fullSupplierName}}</a></span>
        <span v-if="fullSupplierName && !card.SupplierLink" class="item" :title="fullSupplierName">{{fullSupplierName}}</span>
      </div>
      <div class="text-left col-md-3 onHover">
        <ed-button button-class="btn btn-actionbar card-btn primary" href="#" title="Approve" @click.prevent="$emit('onApprove')">Approve</ed-button>
        <ed-button button-class="btn btn-actionbar card-btn" href="#" :title="rejectText" @click.prevent="$emit('onReject')">{{rejectText}}</ed-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div v-if="card.StartDate">
          <span class="item-label full-line">Start</span>
          <span class="item" :title="card.StartDate">{{card.StartDate}}</span>
        </div>
        <div v-if="card.Amount && card.Type === 'Add Card Request'">
          <span class="item-label">Initial Amount</span><br />
          <span class="item" :title="card.Amount">{{card.Amount}}</span>
        </div>
        <div v-if="card.Amount && card.Type === 'Funds Request'">
          <span class="item-label">Request Amount</span><br />
          <span class="item" :title="card.Amount">{{card.Amount}}</span>
        </div>
        <div v-if="card.CardRefillThreshold && card.Type === 'Refill Settings Request'">
          <span class="item-label">Refill Threshold</span><br />
          <span class="item" :title="card.CardRefillThreshold">{{card.CardRefillThreshold}}</span>
        </div>
        <div v-if="card.Amount && card.Type === 'Refill Settings Request'">
          <span class="item-label">Refill Amount</span><br />
          <span class="item" :title="card.Amount">{{card.Amount}}</span>
        </div>
        <div v-if="card.BudgetBalance && (card.Type === 'Add Card Request' || card.Type === 'Funds Request')">
          <span class="item-label">Budget Balance</span><br />
          <span class="item" :title="card.BudgetBalance">{{card.BudgetBalance}}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div v-if="card.Type !== 'Add Card Request' && card.Type !== 'Funds Request' && card.Type !== 'Refill Settings Request' && card.Type !== 'Envelope Approval'">
          <span class="item-label">Amount</span><br />
          <span class="item" :title="card.Amount">{{card.Amount}}</span>
        </div>
        <div v-if="card.CardRefillThreshold && card.Type === 'Add Card Request'">
          <span class="item-label">Refill Threshold</span><br />
          <span class="item" :title="card.CardRefillThreshold">{{card.CardRefillThreshold}}</span>
        </div>
        <div v-if="card.CardHolder && (card.Type === 'Funds Request' || card.Type === 'Refill Settings Request' || card.Type === 'Envelope Approval')">
          <span class="item-label">Card Holder</span><br />
          <span class="item item--holder" :title="holderDisplay">{{ holderDisplay }}</span>
        </div>
        <div v-if="card.CardRefillAmount && card.Type === 'Add Card Request'">
          <span class="item-label">Refill Amount</span><br />
          <span class="item" :title="card.CardRefillAmount">{{card.CardRefillAmount}}</span>
        </div>
        <div v-if="card.CardNumber && (card.Type === 'Funds Request' || card.Type === 'Refill Settings Request' || card.Type === 'Envelope Approval')">
          <span class="item-label">Card Number</span><br />
          <span class="item" :title="card.CardNumber">{{card.CardNumber}}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div v-if="card.Type !== 'Add Card Request' && card.Type !== 'Funds Request' && card.Type !== 'Refill Settings Request'">
          <span class="item-label">{{programLabel}}</span><br />
          <span class="item" :title="card.ProgramName"><a :href="card.ProgramLink">{{card.ProgramName}}</a></span>
        </div>
        <div v-if="card.DivisionName && (card.Type === 'Refill Settings Request' || card.Type === 'Envelope Approval')">
          <span class="item-label">{{divisionLabel}}</span><br />
          <span class="item" :title="card.DivisionName">{{card.DivisionName}}</span>
        </div>
        <div v-if="card.CardHolder && card.Type === 'Add Card Request'">
          <span class="item-label">Card Holder</span><br />
          <span class="item item--holder" :title="holderDisplay">{{ holderDisplay }}</span>
        </div>
        <div v-if="card.CardRequestedBy && (card.Type === 'Add Card Request' || card.Type === 'Funds Request' || card.Type === 'Refill Settings Request')">
          <span class="item-label">Requested By</span><br />
          <span class="item" :title="card.CardRequestedBy">{{card.CardRequestedBy}}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div v-if="card.ProgramOwner">
          <span class="item-label">{{programLabel}} Owner</span><br />
          <span class="item" :title="card.ProgramOwner">{{card.ProgramOwner}}</span>
        </div>
        <div v-if="card.EnvelopeNumber && card.Type === 'Envelope Approval'">
          <span class="item-label">Envelope</span><br />
          <span class="item" :title="card.EnvelopeNumber"><a @click="openEnvelope()" href="javascript:;">{{card.EnvelopeNumber}}</a></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div v-if="card.EndDate">
          <span class="item-label full-line">End</span>
          <span class="item" :title="card.EndDate">{{card.EndDate}}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div v-if="card.BudgetBalance && card.Type !== 'Add Card Request' && card.Type !== 'Funds Request'">
          <span class="item-label">Budget Balance</span><br />
          <span class="item" :title="card.BudgetBalance">{{card.BudgetBalance}}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div v-if="card.ProgramID">
          <span class="item-label">{{programLabel}} Id</span><br />
          <span class="item" :title="card.ProgramID"><a :href="card.ProgramLink">{{card.ProgramID}}</a></span>
        </div>
      </div>
      <div v-if="useMeetingRequestor" class="col-md-3">
        <span class="item-label">{{meetingRequesterName}}</span><br />
        <span class="item" :title="card.MainContactColumnName">{{card.MainContactColumnName}}</span>
      </div>
    </div>
  </div>
</template>
<script>

  import { EventBus } from '@/event-bus'
  import events from '@/core/events/events'

  export default {
    name: 'card',
    props: {
      useMeetingRequestor: Boolean,
      meetingRequesterName: String,
      rejectText: String,
      card: Object,
      programLabel: String,
      divisionLabel: String,
      lastEntry: Boolean
    },

    computed: {
      fullSupplierName() {
        return this.card.SupplierEoNumber
          ? this.card.SupplierName + ' (' + this.card.SupplierEoNumber + ')'
          : this.card.SupplierName
      },
      // Surface the custom Name on Card next to the holder ("Jane Doe | John Smith") when set and
      // meaningfully differs, mirroring the CardHolder.vue two-line layout the cards grid renders.
      // See PRODUCTDEV-5553 for the underlying pattern.
      holderDisplay() {
        const holder = (this.card.CardHolder || '').trim()
        const nameOnCard = (this.card.NameOnCard || '').trim()
        if (!nameOnCard || nameOnCard.toLowerCase() === holder.toLowerCase()) {
          return this.card.CardHolder
        }
        if (!holder) {
          return nameOnCard
        }
        return `${nameOnCard} | ${holder}`
      }
    },

    methods: {
      async getEnvelope(envelopeId) {
        try {
          const response = await this.api.forms.post(this.api.$.evedpaycard.envelopes, {
            sort: 'CreatedDate',
            dir: 'ASC',
            start: 0,
            limit: 100,
            isLiveGrid: true,
            filter: JSON.stringify({ 'EnvelopeId': envelopeId, 'Screen': 'Dashboard', searchTerm: '' })
          })

          if (response && response.data) {
            return response.data.Data[0]
          }
        } catch (error) {
          console.error('Error while retrieving envelopes:', error)
        }
      },

      async openEnvelope() {
        var envelopeIndex = this.card.Id.indexOf('ENVELOPE')
        var envelopeId = ''
        if (envelopeIndex !== -1) {
          envelopeId = this.card.Id.substring(envelopeIndex + 'ENVELOPE'.length)
        }
        const envelope = await this.getEnvelope(envelopeId)
        envelope.FromDashboard = true
        if (this.$user.$.userPermissions.includes('ApprovalDashboard')) {
          await this.$router.push('/d/EnvelopeApprovalDashboard')
        } else {
          await this.$router.push('/d/Programs/>Card/envelopes')
        }
        await EventBus.$emit(events.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope)
      }
    }
  }
</script>
<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";

  a[href] {
    color: $href-blue-color
  }

  .root {
    padding: 0.6rem $xsside-padding;
    font-size: $font-size-small;

    @include theme {
      border-top: 1px solid v(background);
      border-bottom: 1px solid v(background);
    }
  }

  .root:hover .onHover {
    display: block;
  }
  
  .onHover{
    display: none;
  }
  .root + .root {
    border-top: none;
  }

  .root[last=true] {
    border-bottom: none;
  }

  .row {
    padding-bottom: 4px;
    margin-bottom: 4px;
  }

  .row:last-child {
    margin-bottom: 0;
  }

  .row div {
    padding: 0;
    overflow: hidden;
    line-height: normal;
  }
  .card-btn {
    font-size: 10px !important;
    padding: 3px 7px !important;   
    margin-bottom: 3px !important;
  }
  .card-btn.primary{
       color: white !important;
       background:  #4a90e2 !important;
       &:hover {
        color: white;
        background:  #4a90e2;
      }
    }

  .indicator {
    margin-top:10px;
    display: inline-block;
    border-radius: 5px;
    padding: 2px 8px;
    font-size: 0.75rem;
    background-color: $indicator-blue;
    color: white;
    font-weight: 100;
  }

  .red {
    background-color: $indicator-red;
    color: white;
    font-weight: 400;
  }

  .item-label {
    display: inline-block;
    vertical-align: middle;
    font-size: $font-size-xsmall;

    @include theme {
      color: v(ink-light);
    }
  }
  .full-line{
    margin-right: 50px;
  }
  .item {
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
    padding-right: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: $font-size-small;
    @include theme {
      color: v(ink);
    }
  }

  // PRODUCTDEV-5793: the Card Holder value can be a long dual-format string ("Name on Card | Legal
  // Name"). As inline-block the span shrink-wraps to its content, so the max-width:100% ellipsis never
  // engages and the text overflows into the neighbouring column. Block-level makes the width track the
  // column, so the existing nowrap + overflow:hidden + text-overflow:ellipsis truncate it, while the
  // :title attribute still shows the full value on hover.
  .item.item--holder {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/card.vue